export const Copyright = () => {
  return (
    <div className="fixed z-10 bottom-1 left-0 right-0 w-full text-center sm:left-auto sm:right-2 sm:w-auto sm:text-right">
      <small className="text-sm">
        <a
          href="/tokusho"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          特定商取引法について
        </a>
        {" "}
        2012© Shodaryo Office, Inc.
      </small>
    </div>
  );
};
